export const getGstinOrgIdAndGstinNameMap = (
  orgId: string,
  businessHierarchy: any
) => {
  const gstinOrgIdGstinOrgNameMap = new Map<string, string>();

  businessHierarchy.businessDataStore[orgId].__children.forEach(
    (element: any) => {
      gstinOrgIdGstinOrgNameMap.set(element.id, element.name);
    }
  );
  return gstinOrgIdGstinOrgNameMap;
};
